import { action } from 'typesafe-actions'

import { Food, FoodImageType } from './foods'

export enum foodsActionType {
  FETCH_FOODS = 'FETCH_FOODS',
  FETCH_FOODS_SUCCEEDED = 'FETCH_FOODS_SUCCEEDED',
  FETCH_FOOD = 'FETCH_FOOD',
  FETCH_FOOD_SUCCEEDED = 'FETCH_FOOD_SUCCEEDED',
  FETCH_FOODS_EVERY = 'FETCH_FOODS_EVERY',
  FETCH_FOODS_EVERY_FINISHED = 'FETCH_FOODS_EVERY_FINISHED',
  SET_CURRENT_BRAND_CODE = 'SET_CURRENT_BRAND_CODE',
  SET_FOOD = 'SET_FOOD',
  SET_FOOD_SUCCEEDED = 'SET_FOOD_SUCCEEDED',
  UPLOAD_FOOD_IMAGE = 'UPLOAD_FOOD_IMAGE',
  SET_FOOD_IMAGE_URL = 'SET_FOOD_IMAGE_URL',
  CREATE_FOOD = 'CREATE_FOOD',
  CREATE_FOOD_SUCCEEDED = 'CREATE_FOOD_SUCCEEDED',
  CHANGE_FOODS_INDEX = 'CHANGE_FOODS_INDEX',
  THROW_ERROR = 'THROW_ERROR',
}

export const foodsActions = {
  fetchFoods: (brandCode?: string | null) =>
    action(foodsActionType.FETCH_FOODS, { brandCode }),
  setCurrentBrandCode: (brandCode: string | null) =>
    action(foodsActionType.SET_CURRENT_BRAND_CODE, { brandCode }),
  fetchFoodsSucceeded: (foods: Food[]) =>
    action(foodsActionType.FETCH_FOODS_SUCCEEDED, { foods }),
  fetchFood: (foodId: number) => action(foodsActionType.FETCH_FOOD, { foodId }),
  fetchFoodSucceeded: (food: Food) =>
    action(foodsActionType.FETCH_FOOD_SUCCEEDED, { food }),
  fetchFoodsEvery: () => action(foodsActionType.FETCH_FOODS_EVERY),
  fetchFoodsEveryFinished: () =>
    action(foodsActionType.FETCH_FOODS_EVERY_FINISHED),
  setFood: (foodId: number, food: Food) =>
    action(foodsActionType.SET_FOOD, { foodId, food }),
  setFoodSucceeded: () => action(foodsActionType.SET_FOOD_SUCCEEDED),
  uploadFoodImage: (foodId: number, foodImageType: FoodImageType, file: File) =>
    action(foodsActionType.UPLOAD_FOOD_IMAGE, {
      foodId,
      foodImageType,
      file,
    }),
  setImageUrl: (fileName: string, url: string, foodImageType: FoodImageType) =>
    action(foodsActionType.SET_FOOD_IMAGE_URL, {
      fileName,
      url,
      foodImageType,
    }),
  createFood: (food: Food, brandCode?: string) =>
    action(foodsActionType.CREATE_FOOD, { food, brandCode }),
  createFoodSucceeded: () => action(foodsActionType.CREATE_FOOD_SUCCEEDED),
  changeFoodsIndex: (ids: number[]) =>
    action(foodsActionType.CHANGE_FOODS_INDEX, { ids }),
  throwError: (error: Error) => action(foodsActionType.THROW_ERROR, { error }),
}
